module.exports = __webpack_public_path__ + "img/customerCaseTop.f4811f64.png";